import styled from 'styled-components';
import { Input, Pagination, Select, Button as AntButton } from 'antd';

export const TableWrapper = styled.div`
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};
    border-radius: 6px;
    padding: 0;
    border: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return `1px solid ${isDark ? '#2C2C2C' : '#E5E5E5'}`;
    }};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: ${({ $topMargin }) => $topMargin ? '24px' : '0'};
    overflow: hidden;

    @media (max-width: 768px) {
        margin-top: ${({ $topMargin }) => $topMargin ? '20px' : '0'};
    }

    @media (max-width: 480px) {
        margin-top: ${({ $topMargin }) => $topMargin ? '16px' : '0'};
    }
`;

export const TableHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ theme }) => theme.spacing.lg};
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing.md};
    height: 90px;
    min-height: 90px;
    max-height: 90px;
    box-sizing: border-box;

    @media (max-width: 1024px) {
        padding: 20px;
        height: auto;
        min-height: auto;
        max-height: none;
    }

    @media (max-width: 768px) {
        padding: 16px;
        gap: 12px;
    }

    @media (max-width: 480px) {
        padding: 12px;
        gap: 10px;
    }
`;

export const TableTitle = styled.h2`
    font-size: 24px;
    font-weight: 600;
    color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }};
    margin: 0;
    font-family: var(--font-family-lufga);
    user-select: none;
    cursor: default;

    @media (max-width: 1024px) {
        font-size: 22px;
    }

    @media (max-width: 768px) {
        font-size: 20px;
    }

    @media (max-width: 480px) {
        font-size: 18px;
    }
`;

export const TableActions = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

export const TableSearchInput = styled(Input)`
    width: 343px;
    height: 44px;
    border-radius: 6px;

    @media (max-width: 1024px) {
        width: 280px;
        height: 40px;
        border-radius: 6px;
    }

    @media (max-width: 768px) {
        width: 200px;
        height: 36px;
        border-radius: 6px;
    }

    @media (max-width: 480px) {
        width: 100%;
        height: 36px;
        border-radius: 6px;
    }
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#F0F0F0';
    }};
    border: none;
    
    .ant-input {
        font-family: var(--font-family-lufga);
        font-size: 16px;
        font-weight: 400;
        color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }};
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#F0F0F0';
    }};
        
        &::placeholder {
            color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }};
        }
    }
    
    .ant-input-prefix {
        margin-right: 13px;
        
        .anticon {
            font-size: 18px;
            color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }};
        }
    }
    
    &:hover {
        border: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#E5E5E5';
    }};
        box-shadow: none;
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#F0F0F0';
    }};
        
        .ant-input {
            background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#F0F0F0';
    }};
        }
    }
    
    &:focus, &.ant-input-affix-wrapper-focused {
        border-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#F0F0F0';
    }};
        box-shadow: none;
    }
`;

export const TableSelect = styled(Select)`
    width: auto;
    min-width: 120px;
    height: 44px;
    
    .ant-select-selector {
        height: 44px !important;
        border-radius: 6px !important;
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#F0F0F0';
    }} !important;
        border: none !important;
        padding: 0 16px !important;
        
        .ant-select-selection-item {
            line-height: 44px !important;
            font-family: var(--font-family-lufga) !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }} !important;
        }
        
        .ant-select-selection-placeholder {
            line-height: 44px !important;
            font-family: var(--font-family-lufga) !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }} !important;
        }
        
        .ant-select-selection-search-input {
            font-size: 14px !important;
            font-weight: 500 !important;
            font-family: var(--font-family-lufga) !important;
        }
        
        .ant-select-selection-item,
        .ant-select-selection-placeholder {
            font-size: 14px !important;
            font-weight: 500 !important;
        }
    }
    
    .ant-select-arrow {
        color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#000000';
    }} !important;
    }
    
    &:hover .ant-select-selector {
        border: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#E5E5E5';
    }} !important;
        box-shadow: none !important;
    }
    
    &.ant-select-focused .ant-select-selector {
        border: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#E5E5E5';
    }} !important;
        box-shadow: none !important;
    }
`;

export const TableSelectDropdown = styled.div`
    .ant-select-item {
        font-size: 14px !important;
        font-weight: 500 !important;
        font-family: var(--font-family-lufga) !important;
        line-height: 1.5 !important;
        
        .ant-select-item-option-content {
            font-size: 14px !important;
            font-weight: 500 !important;
            font-family: var(--font-family-lufga) !important;
        }
    }
`;

export const ResetStatusButton = styled(AntButton)`
    font-size: 14px !important;
    font-weight: 500 !important;
    font-family: var(--font-family-lufga) !important;
    text-align: center !important;
    
    &:hover {
        background: transparent !important;
    }
`;

export const TableActionButton = styled.button`
    width: 43px;
    height: 43px;
    border-radius: 50%;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : 'rgb(83, 83, 83)';
    }};
    font-size: 14px;
    font-weight: 500;
    border: 1.5px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : 'rgb(83, 83, 83)';
    }};
    flex-shrink: 0;
    cursor: pointer;
    transition: all 0.2s;
    
    .anticon {
        color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : 'rgb(83, 83, 83)';
    }};
        font-size: 24px;
    }

    @media (max-width: 1024px) {
        width: 40px;
        height: 40px;
        padding: 9px;
        
        .anticon {
            font-size: 22px;
        }
    }

    @media (max-width: 768px) {
        width: 36px;
        height: 36px;
        padding: 8px;
        
        .anticon {
            font-size: 20px;
        }
    }

    @media (max-width: 480px) {
        width: 32px;
        height: 32px;
        padding: 7px;
        
        .anticon {
            font-size: 18px;
        }
    }
    
    &:hover {
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)';
    }};
        border: 1.5px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : 'rgb(83, 83, 83)';
    }};
        
        .anticon {
            color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : 'rgb(83, 83, 83)';
    }};
        }
    }

    &:disabled {
        opacity: 0.45;
        cursor: not-allowed;
        background: transparent;
        border-color: ${({ theme }) => theme.colors.border.default};
        color: ${({ theme }) => theme.colors.text.secondary};
    }

    &:disabled:hover {
        background: transparent;
    }
`;

export const TableContent = styled.div`
    // padding: 0 ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.lg};

    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C #1A1A1A' : '#E5E5E5 #F5F5F5';
    }};

    &::-webkit-scrollbar {
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#1A1A1A' : '#F5F5F5';
    }};
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
        border-radius: 4px;
        
        &:hover {
            background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#3C3C3C' : '#D5D5D5';
    }};
        }
    }

    @media (max-width: 1024px) {
        padding: 0 20px 20px 20px;
    }

    @media (max-width: 768px) {
        padding: 0 16px 16px 16px;
    }

    @media (max-width: 480px) {
        padding: 0 12px 12px 12px;
    }
`;

export const StyledTable = styled.table`
    width: 100%;
    min-width: 800px;
    border-collapse: collapse;
    border-radius: 0;
    overflow: visible;
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};

    @media (max-width: 1024px) {
        min-width: 700px;
    }

    @media (max-width: 768px) {
        min-width: 600px;
    }

    @media (max-width: 480px) {
        min-width: 500px;
    }
`;

export const TableHead = styled.thead`
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#F5F5F5';
    }};
`;

export const TableHeaderRow = styled.tr``;

export const TableHeaderCell = styled.th`
    padding: 16px 24px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
    border-bottom: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
    font-family: var(--font-family-lufga);
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 10;
    
    &:first-child {
        text-align: left;
        padding-left: ${({ theme }) => theme.spacing.lg};
    }
    
    &:not(:first-child) {
        text-align: center;
    }
    
    &:last-child {
        padding-right: ${({ theme }) => theme.spacing.lg};
    }

    @media (max-width: 1024px) {
        padding: 14px 20px;
        font-size: 13px;
        
        &:first-child {
            padding-left: 20px;
        }
        
        &:last-child {
            padding-right: 20px;
        }
    }

    @media (max-width: 768px) {
        padding: 12px 16px;
        font-size: 12px;
        
        &:first-child {
            padding-left: 16px;
        }
        
        &:last-child {
            padding-right: 16px;
        }
    }

    @media (max-width: 480px) {
        padding: 10px 12px;
        font-size: 11px;
        
        &:first-child {
            padding-left: 12px;
        }
        
        &:last-child {
            padding-right: 12px;
        }
    }
`;

export const TableBody = styled.tbody``;

export const EmptyStateCell = styled.td`
    padding: 40px 24px;
    text-align: center;
`;

export const EmptyStateWrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: ${({ theme }) => theme.colors.text.secondary};
`;

export const EmptyStateIcon = styled.div`
    width: 44px;
    height: 44px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)';
    }};
    color: ${({ theme }) => theme.colors.text.primary};
`;

export const EmptyStateText = styled.div`
    font-size: 14px;
    font-weight: 500;
    font-family: var(--font-family-lufga);
`;

export const TableRow = styled.tr`
    border-bottom: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
    transition: background 140ms ease, box-shadow 140ms ease;
    
    &:last-child {
        border-bottom: none;
        
        td:first-child {
            border-bottom-left-radius: 6px;
        }
        
        td:last-child {
            border-bottom-right-radius: 6px;
        }
    }
    
    ${({ $hoverable }) => $hoverable && `
    &:hover {
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.035)';
    }};
        box-shadow: inset 0 0 0 1px ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255, 255, 255, 0.10)' : 'rgba(0, 0, 0, 0.06)';
    }};
    }

    &:hover td {
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.035)';
    }};
    }
    `}
`;

export const TableCell = styled.td`
    padding: 16px 24px;
    font-size: 14px;
    font-weight: 500;
    color: #74828F;
    font-family: var(--font-family-lufga);
    text-align: center;
    white-space: nowrap;
    
    &:first-child {
        text-align: left;
        padding-left: ${({ theme }) => theme.spacing.lg};
    }
    
    &:not(:first-child) {
        text-align: center;
    }
    
    &:last-child {
        padding-right: ${({ theme }) => theme.spacing.lg};
    }

    @media (max-width: 1024px) {
        padding: 14px 20px;
        font-size: 13px;
        
        &:first-child {
            padding-left: 20px;
        }
        
        &:last-child {
            padding-right: 20px;
        }
    }

    @media (max-width: 768px) {
        padding: 12px 16px;
        font-size: 12px;
        
        &:first-child {
            padding-left: 16px;
        }
        
        &:last-child {
            padding-right: 16px;
        }
    }

    @media (max-width: 480px) {
        padding: 10px 12px;
        font-size: 11px;
        
        &:first-child {
            padding-left: 12px;
        }
        
        &:last-child {
            padding-right: 12px;
        }
    }
`;


export const ActionLinks = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 400;
    font-family: var(--font-family-lufga);
    
    a {
        color: #F04A4A;
        text-decoration: underline;
        cursor: pointer;
        transition: opacity 0.2s;
        
        &:hover {
            opacity: 0.8;
        }
    }
    
    span {
        color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
    }
`;

export const TablePagination = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 26px;
    padding-top: 16px;
    padding-left: ${({ theme }) => theme.spacing.lg};
    border-top: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
    position: sticky;
    left: 0;
    background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};
    z-index: 5;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 1024px) {
        padding-left: 20px;
    }

    @media (max-width: 768px) {
        padding-left: 16px;
    }

    @media (max-width: 480px) {
        padding-left: 12px;
    }
`;

export const StyledPagination = styled(Pagination)`
    .ant-pagination {
        font-family: var(--font-family-lufga);
    }
    
    .ant-pagination-item {
        border-radius: 6px;
        border: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};
        
        a {
            color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
            font-size: 14px;
            font-weight: 500;
        }
        
        &:hover {
            border-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#F04A4A';
    }};
            background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#FAFAFA';
    }};
            
            a {
                color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#F04A4A';
    }};
            }
        }
        
        &.ant-pagination-item-active {
            border-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#F04A4A';
    }};
            background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#F04A4A';
    }};
            
            a {
                color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#000000' : '#ffffff';
    }};
            }
            
            &:hover {
                border-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#F04A4A';
    }};
                background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#F04A4A';
    }};
            }
        }
    }
    
    .ant-pagination-prev,
    .ant-pagination-next {
        border-radius: 6px;
        border: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
        background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};
        
        .ant-pagination-item-link {
            color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
        }
        
        &:hover:not(.ant-pagination-disabled) {
            border-color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#F04A4A';
    }};
            background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#FAFAFA';
    }};
            
            .ant-pagination-item-link {
                color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#F04A4A';
    }};
            }
        }
        
        &.ant-pagination-disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }
    
    .ant-pagination-options {
        .ant-select {
            .ant-select-selector {
                border-radius: 6px;
                border: 1px solid ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#2C2C2C' : '#E5E5E5';
    }};
                background: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? theme.colors.background.secondary : '#ffffff';
    }};
                color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
            }
        }
    }
    
    .ant-pagination-total-text {
        color: ${({ theme }) => {
        const isDark = theme.colors.background.default === '#141414';
        return isDark ? '#ffffff' : '#292929';
    }};
        font-size: 14px;
        font-weight: 400;
        font-family: var(--font-family-lufga);
    }
`;

